import { styled } from '@silverstein-properties/inspirelabs-ui';

export const StyledExperiencePhoto = styled('img')(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
}));
